import { gql } from '@apollo/client'

export const Query = gql`
  query EditMaintenanceEvent($companyId: ID!, $filters: MaintenanceEventFilters) {
    maintenanceEvents(companyId: $companyId, filters: $filters, first: 1) {
      nodes {
        id
        details
        asset {
          id
          name
        }
        maintenanceType {
          id
          name
          maintenanceTypeTasks {
            id
            name
            required
          }
        }
        startedAt
        state
        result
        maintenanceTasks {
          nodes {
            id
            result
            maintenanceTypeTask { id }
          }
        }
        extraData
      }
    }
  }
`
